import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M26.847 22.756h-4.5c-.6 0-1.1-.5-1.1-1.2v-14.8c0-.3.1-.6.3-.8.2-.2.5-.4.8-.4h4.5c.3 0 .6.1.8.3.2.2.3.5.3.9v14.8c.1.6-.4 1.2-1.1 1.2zm-4.2-1.4h4.1v-14.5h-4.1v14.5zm-4.6 6.3h-4.5c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.9v-19.7c0-.3.1-.6.3-.9.2-.2.5-.4.8-.3h4.5c.3 0 .6.1.8.3.2.2.3.5.3.9v19.7c0 .3-.1.6-.3.9s-.5.3-.8.3zm-4.3-1.4h4.2v-19.4h-4.2v19.4zm-4.5-8.7h-4.4c-.6 0-1.1-.5-1.1-1.2v-9.6c0-.3.1-.6.3-.9.2-.2.5-.4.8-.3h4.5c.3 0 .6.1.8.4.2.2.3.5.3.8v9.6c-.1.7-.6 1.2-1.2 1.2zm-4.3-1.4h4.1v-9.3h-4.1v9.3z' })
));